<template>
  <div class="card-body " :class="classes">
    <!-- @slot Conteudo -->
    <slot></slot>
  </div>
</template>
<script>
/**
 * Conteudo de um card
 */
export default {
  name: "HcCardBody",
  props: {
    /**
     * Define se conteudo deve ser centralizado
     * @values {boolean} true, false
     */
    centralizar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        { "justify-content-center": this.centralizar },
        { "d-flex": this.centralizar }
      ];
    }
  }
};
</script>
